/* Meller — hover na bolinha faz preview da cor no card (sem clicar), restaura ao sair */
(function () {
  if (window.__mlrSwatchInit) return;
  window.__mlrSwatchInit = true;

  function cardOf(el) { return el.closest('product-card, .product-card'); }
  function mainImg(c) { return c.querySelector('.product-media__image'); }
  function cardLink(c) { return c.querySelector('.product-card__link') || c.querySelector('a[href*="/products/"]'); }

  function initCard(c) {
    if (c.dataset.mlrInit) return;
    var dots = Array.prototype.slice.call(c.querySelectorAll('.meller-dot[data-img]'));
    if (dots.length < 2) return;
    c.dataset.mlrInit = '1';

    var img = mainImg(c);
    var lk = cardLink(c);
    var defActive = c.querySelector('.meller-dot.on') || dots[0];
    var origSrc = img ? img.getAttribute('src') : null;
    var origSrcset = img ? img.getAttribute('srcset') : null;
    var origHref = lk ? lk.getAttribute('href') : null;

    function preview(d) {
      if (img && d.dataset.img) { img.setAttribute('srcset', ''); img.setAttribute('src', d.dataset.img); }
      if (lk && d.dataset.url) lk.setAttribute('href', d.dataset.url);
      dots.forEach(function (x) { x.classList.remove('on'); });
      d.classList.add('on');
    }
    function restore() {
      if (img) { if (origSrcset !== null) img.setAttribute('srcset', origSrcset); if (origSrc !== null) img.setAttribute('src', origSrc); }
      if (lk && origHref !== null) lk.setAttribute('href', origHref);
      dots.forEach(function (x) { x.classList.remove('on'); });
      if (defActive) defActive.classList.add('on');
    }

    dots.forEach(function (d) { d.addEventListener('mouseenter', function () { preview(d); }); });
    c.addEventListener('mouseleave', restore);
  }

  function scan() { document.querySelectorAll('product-card, .product-card').forEach(initCard); }
  if (document.readyState !== 'loading') scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);

  // ícone de carrinho no card: adiciona direto ao carrinho (sem ir pra página)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mlr-cart');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var vid = btn.getAttribute('data-vid');
    if (!vid || btn.dataset.busy) return;
    if (btn.getAttribute('data-available') === '0') { window.location = btn.closest('product-card, .product-card').querySelector('a[href*="/products/"]').href; return; }
    btn.dataset.busy = '1';
    btn.classList.add('mlr-cart--loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.classList.remove('mlr-cart--loading');
        btn.classList.add('mlr-cart--done');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // atualiza o contador do carrinho no header
        document.querySelectorAll('.cart-count, [data-cart-count], cart-icon [data-count], .header-actions__cart-count, .cart-bubble').forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
        // tenta abrir o cart drawer do tema, se existir
        var drawer = document.querySelector('cart-drawer-component, cart-drawer, [data-cart-drawer]');
        if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (x) {} }
        setTimeout(function () { btn.classList.remove('mlr-cart--done'); btn.dataset.busy = ''; }, 1600);
      })
      .catch(function () { btn.classList.remove('mlr-cart--loading'); btn.dataset.busy = ''; });
  }, true);
})();
